import Button from "@mui/material/Button/Button";
import { useTranslation } from "react-i18next";

/**
 * The generic load-failure content: headline, hint and a reload action.
 * Embeddable anywhere; the standalone error page wraps it full-screen.
 *
 * Lives apart from the error page because the translation extractor applies a
 * file's translation namespace to every key in it, and the error page uses the
 * server-message namespace.
 */
export function ErrorContent({ errorMessage }: { errorMessage?: string }) {
  const { t } = useTranslation();
  return (
    <div>
      <div className="text-[26px] font-medium">
        {t("The server is not responding")}
      </div>
      <div className="mt-[20px] whitespace-pre-line text-xl">
        {errorMessage?.trim() ||
          t("Please wait a moment and then reload the page.")}
      </div>
      <RefreshButton />
    </div>
  );
}

function RefreshButton() {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      variant="contained"
      onClick={() => {
        window.location.reload();
      }}
      sx={{
        borderRadius: 3,
        paddingY: 0.2,
        paddingX: 1.8,
        marginTop: 5,
      }}
    >
      {t("Reload page")}
    </Button>
  );
}
